import { useStudioStore } from '@/store/useStudioStore';
import { Dialog, DialogContent, DialogTitle, DialogClose } from '@/components/ui/dialog';
import { X } from 'lucide-react';

const getHistoryStatusLabel = (status: string) => {
  if (status === 'review') return 'Needs review';
  if (status === 'dismissed') return 'Kept current';
  if (status === 'pending') return 'In progress';
  return 'Applied';
};

export const StudioHistoryModal = () => {
  const { isHistoryModalOpen, setHistoryModalOpen, selectedHistoryItem: item } = useStudioStore();

  if (!item) return null;

  return (
    <Dialog open={isHistoryModalOpen} onOpenChange={setHistoryModalOpen}>
      <DialogContent
        className="hist-modal border-border max-w-[min(560px,100%)] gap-0 overflow-hidden rounded-[16px] bg-white p-0 shadow-[0_24px_54px_rgba(13,13,26,0.3)] ring-0"
        showCloseButton={false}
        aria-describedby={undefined}
      >
        <div className="hist-modal-head border-border flex items-center justify-between gap-3 border-b p-[14px_16px]">
          <DialogTitle className="hist-modal-title text-[16px] leading-[1.35] font-extrabold text-[#0D0D1A]">
            <div>{item.title}</div>
          </DialogTitle>
          <DialogClose asChild>
            <button
              type="button"
              className="hist-modal-close border-border flex h-[30px] w-[30px] shrink-0 cursor-pointer items-center justify-center rounded-[8px] border bg-white text-[#0D0D1A]/38 transition-all hover:border-[rgba(109,40,217,0.32)] hover:bg-[rgba(109,40,217,0.04)] hover:text-[#6D28D9]"
            >
              <X size={14} />
            </button>
          </DialogClose>
        </div>

        <div className="hist-modal-meta border-border flex flex-wrap gap-2 border-b bg-[rgba(247,247,252,0.85)] p-[9px_16px]">
          <span className="hist-meta-chip border-border rounded-full border bg-white p-[3px_10px] text-[11px] font-semibold text-[#0D0D1A]/56">
            {item.at}
          </span>
          <span className="hist-meta-chip border-border rounded-full border bg-white p-[3px_10px] text-[11px] font-semibold text-[#0D0D1A]/56">
            {item.source}
          </span>
          <span className="hist-meta-chip border-border rounded-full border bg-white p-[3px_10px] text-[11px] font-semibold text-[#0D0D1A]/56">
            {getHistoryStatusLabel(item.status)}
          </span>
        </div>

        <div className="hist-modal-body max-h-[min(56vh,420px)] overflow-auto p-[14px_16px_16px] text-[13px] leading-[1.68] whitespace-pre-wrap text-[#0D0D1A]/56">
          {item.detail}
        </div>
      </DialogContent>
    </Dialog>
  );
};
